<div class="verify-container">
  <div class="verify-card">
    <img src="../../../../assets/images/logo.png" alt="PaperTrl logo" class="logo" />

    <h2 class="title">Please verify your email</h2>
    <p class="subtitle">
      We’ve sent a confirmation link, Please check your inbox (and spam folder).
    </p>

    <div class="grid">
      <div class="col-12">
        <button pButton class="p-button-outlined p-button-lg flex-column full-width" (click)="onResend()"
          [disabled]="isResendDisabled">
          <span *ngIf="!isResendDisabled">Send verification email</span>
          <span *ngIf="isResendDisabled">Resend in {{ countdownSeconds }}s</span>
        </button>
      </div>
      <div class="col-12">
        <button pButton class="p-button-lg flex-column full-width" (click)="onBackToLogin()">I have verified – Back to
          login</button>
      </div>
      <div class="col-12">
        <button class="logout" (click)="onLogout()">Logout</button>
      </div>
    </div>

    <p class="footnote">
      Didn’t get the email? It might take a minute.
      Need help? <a href="mailto:support@papertrl.com">Contact support</a>.
    </p>
  </div>
</div>
